import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import Icon from "../elements/icon";
import Input from "./input";
import InputControlsWrap from "./input-controls-wrap";

const { any, string, func, bool, number } = PropTypes;

class SearchInput extends React.Component {
  static displayName = "SearchInput";

  static propTypes = {
    className: string,
    name: string,
    placeholder: string,
    searchIcon: bool,
    clearable: bool,
    focusOnMount: bool,
    width: any,

    onFocus: func,
    onBlur: func,
    onClear: func,

    onChange: func,
    value: string,
    forwardedRef: any,

    debounceTimeout: number,
  };

  static defaultProps = {
    width: "100%",
    placeholder: "Search...",
    searchIcon: true,
    clearable: true,
  };

  state = {
    targetValue: this.props.value,
  };

  onChangeEvent = ({ target }) => {
    this.setState({ targetValue: target.value });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      if (this.props.value !== this.state.targetValue) {
        this.setState({ targetValue: this.props.value });
      }
    }
  }

  handleClear = () => {
    this.setState({ targetValue: "" });
    this.props.onChange("");
    this.props.onClear && this.props.onClear();
  };

  render() {
    return (
      <InputControlsWrap
        icon={this.props.searchIcon && "search"}
        onClear={this.props.clearable && this.handleClear}
        hasValue={this.state.targetValue}
        width={this.props.width}
      >
        <Input
          className={classNames("search-input--input", this.props.className)}
          ref={this.props.forwardedRef}
          type="search"
          data-testid="search-input"
          name={this.props.name}
          value={this.props.value}
          placeholder={this.props.placeholder}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          onChange={this.props.onChange}
          onChangeEvent={this.onChangeEvent}
          debounceTimeout={this.props.debounceTimeout}
          focusOnMount={this.props.focusOnMount}
        />
      </InputControlsWrap>
    );
  }
}

export default React.forwardRef((props, ref) => <SearchInput {...props} forwardedRef={ref} />);
